import { Dialog, styled } from "@mui/material";
import { senecColors } from "src/styles/senecBaseThemePalette";

export const StyledDialog = styled(Dialog)(() => {
    return {
        "& .MuiDialog-paper": {
            borderRadius: "0.75rem",
        },
        "& .MuiBackdrop-root.MuiModal-backdrop": {
            backgroundColor: senecColors.neutralGray10Transparency70,
        },
    };
});
